'use client';

import { ChevronUp } from 'lucide-react';
import { useEffect, useState } from 'react';

import IconButton from '@/components/common/IconButton';

const MoveToTop = () => {
  const [isGoToTop, setIsGoToTop] = useState<boolean>(false);

  const scrollHandler = () => {
    if (window.scrollY > 1024) {
      setIsGoToTop(true);
    } else {
      setIsGoToTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return (
    <IconButton
      icon={<ChevronUp />}
      className={`circle-button-shinny !size-12 rounded-full !p-0 transition-all duration-500 ${
        isGoToTop ? 'opacity-100' : 'opacity-0'
      }`}
      type="button"
      onClick={() => window.scroll({ top: 0 })}
      aria-label="Move to top"
    />
  );
};

export default MoveToTop;
